/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 검색된 데이터가 없다는 내용을 표기하는 컴포넌트
 * 
 * -----------------------------------------------------------------------------------------------
 */

import { NoResultIcon } from 'common-modules/general/assets/Styles/Mobile/icon';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

const Icon = styled(NoResultIcon)`
  margin-bottom: 1rem;
`;

interface Props {
  children: React.ReactNode;
}

const NoResultWithLabel = ({ children }: Props) => {
  return (
    <Container>
      <Icon /> <div>{children}</div>
    </Container>
  );
};

export default NoResultWithLabel;
